import { render, staticRenderFns } from "./ztyj.vue?vue&type=template&id=96facd50&"
import script from "./ztyj.vue?vue&type=script&lang=js&"
export * from "./ztyj.vue?vue&type=script&lang=js&"
import style0 from "./ztyj.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports